import {h, Fragment} from "preact"
import RecomendationSection from './RecomendationSection'

export default function NoResults() {
    return (
      <div class="ss__no-results">
        <div class="ss__no-results__container">
          <h4 class="ss__title" aria-level="2" role="heading">Suggestions</h4>
          <ul class="ss__no-results__suggestions">
            <li>Check for misspellings.</li>
            <li>Remove possible redundant keywords (ie. "products").</li>
            <li>Use other words to describe what you are searching for.</li>
          </ul>
        </div>
        <RecomendationSection />
      </div>
    )
}
